
import React from 'react';
import { Award } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';
import { CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { ColorScheme } from '@/types/trader';
import { iconColorMap } from '@/components/premium-bots/utils/styles';
import { useIsMobile } from '@/hooks/use-mobile';

interface CardHeaderProps {
  name: string;
  description: string;
  propFirm: string;
  colorScheme?: ColorScheme;
  isLoading?: boolean;
  isInstantAccount?: boolean;
}

export const PropBotCardHeader = ({
  name,
  description,
  propFirm,
  colorScheme,
  isLoading = false,
  isInstantAccount = false,
}: CardHeaderProps) => {
  const iconStyle = colorScheme ? iconColorMap[colorScheme] : 'text-primary';
  const isMobile = useIsMobile();

  return (
    <CardHeader className={`${isMobile ? "pb-2 pt-4 px-4" : "pb-2"} text-center`}>
      <div className="flex flex-col items-center gap-2">
        <Award className={cn(`${isMobile ? "h-6 w-6" : "h-8 w-8"}`, iconStyle)} />
        <CardTitle className={`font-medium ${isMobile ? "text-base" : "text-lg"}`}>{name}</CardTitle>
        
        <div className="flex flex-col items-center gap-2">
          {isInstantAccount && (
            <Badge className="bg-gradient-to-r from-amber-500 to-yellow-600 text-white border-0 font-semibold">
              INSTANT ACCOUNT
            </Badge>
          )}
          {propFirm && (
            <Badge variant="outline" className={cn(
              "border-blue-500/20",
              isInstantAccount ? "bg-amber-500/10 text-amber-600 border-amber-500/20" : "bg-blue-500/10 text-blue-500"
            )}>
              {propFirm}
            </Badge>
          )}
        </div>
      </div>
      
      <CardDescription className={`line-clamp-2 ${isMobile ? "h-8 mt-2 text-xs" : "h-10 mt-3"} text-center`}>
        {isLoading ? (
          <div className="animate-pulse bg-muted rounded h-4 w-3/4 mx-auto"></div>
        ) : (
          description
        )}
      </CardDescription>
    </CardHeader>
  );
};
